import { yupResolver } from '@hookform/resolvers/yup';
import {
  Button,
  TextField
} from '@mui/material';
import Box from '@mui/material/Box';
import { DatePicker } from '@mui/x-date-pickers';
import { enqueueSnackbar } from 'notistack';
import { useEffect, useMemo, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useLocation, useNavigate, useParams } from 'react-router';
import FormProvider, { RHFAutocomplete, RHFTextField } from 'src/components/hook-form';
import ProjectManagerADD from 'src/components/risk-project-user-drop/project-user-drop';
import { useRouter } from 'src/routes/hooks';
import { getRequest, postRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import * as Yup from 'yup';
import { handleErrorMessages } from '../../risk-register/feching';
import WeeklyPayrolltable from './weekly-payroll-timesheet-table';

const addDays = (date, days) => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};


const WeeklyPayroll = () => {
  const [ tableData, setTableData ] = useState([]);
  const [ projectList, setProjectList ] = useState([]);
  const [ loading, setLoading ] = useState(false);

  const { id } = useParams();
  const router = useRouter()
  const navigate = useNavigate();
  
  const location = useLocation();
  const rowData = location?.state?.rowData;
  console.log("🚀 ~ WeeklyPayroll ~ rowData:", rowData)

  const getWeeklytimeSheetData = async (week_starting_date) => {
    try {
      const data = await getRequest(
        `${endpoints.accounting.payroll.weeklyPayroll.get_time_sheet}/${week_starting_date}?project_id=${id}`
      );
      if (data) {
        setTableData(data);
      }
    } catch (error) {
      console.error('Error fetching weekly timesheet data:', error);
    }
  };

  const handleBack = () => {
    router.back()
  };
  const NewUserSchema = Yup.object().shape({
  });

const defaultValues = useMemo(() => {
  const today = new Date();
  return {
    week_starting_date: rowData?.week_starting_date ? new Date(rowData.week_starting_date) : today,
    week_ending_date: rowData?.week_starting_date ? addDays(new Date(rowData.week_starting_date), 6) : addDays(today, 6),
    facility: rowData?.facility || null,
    supervisor_id: rowData?.supervisor?.id || null,
    scope_of_work: rowData?.scope_of_work || '',
    job_order_number: rowData?.job_order_number || '',
  };
}, [rowData]);


  const methods = useForm({
    resolver: yupResolver(NewUserSchema),
    defaultValues,
  });

  const {
    reset,
    watch,
    control,
    setValue,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  useEffect(() => {
    const getProjects = async () => {
      const data = await getRequest(endpoints.accounting.expenses.get_project_list);
      if (data) {
        setProjectList(data);
        const matchedFacility = data?.find((project) => String(project.id) === String(id));
        if (matchedFacility) {
          setValue('facility', matchedFacility);
          setValue('job_order_number', matchedFacility.contract_number || '');
        }
      }
    };
    getProjects();
  }, [ id, setValue ]);

  const week_starting_date = watch('week_starting_date');
  const selectedSupervisor = watch('supervisor_id'); // Watch the selected supervisor


  useEffect(() => {
    if (week_starting_date) {
      const newEndDate = addDays(week_starting_date, 6);
      setValue('week_ending_date', newEndDate);
      const formattedDate = week_starting_date.toISOString().split('T')[ 0 ];
      getWeeklytimeSheetData(formattedDate);
    }
  }, [ week_starting_date, setValue ]);

  useEffect(() => {
    reset(defaultValues);
  }, [ reset, defaultValues ]);

  const onSubmit = handleSubmit(async (data) => {
    const formData = new FormData();
    formData.append('week_starting_date', data.week_starting_date.toISOString().split('T')[ 0 ]);
    formData.append('week_ending_date', data.week_ending_date.toISOString().split('T')[ 0 ]);
    formData.append('project_id', data.facility?.id || '');
    formData.append('supervisor_id', data.supervisor_id || ''); // Ensure the supervisor ID is correctly appended
    formData.append('scope_of_work', data.scope_of_work || '');
    formData.append('project_number', data.job_order_number || '');
        formData.forEach((value, key) => console.log('>>>>>>>',key, value));
    setLoading(true)
    try {

         const response = await postRequest(
          rowData?.id
                ? `${endpoints.accounting.payroll.weeklyPayroll.update_payrolls}/${rowData.id}?_method=PUT`
                : endpoints.accounting.payroll.weeklyPayroll.update_payrolls,
              formData,
              true
            );
      setLoading(false);

      if (response.metadata?.success) {
        reset(); 
        navigate(`/accounts-management/payroll-project-list/payroll/${id}`);
        enqueueSnackbar({
          variant: 'success',
          message: response.metadata.message,
        });
      } else {
        handleErrorMessages(response.metadata?.message || 'Something went wrong.');
      }
    } catch (error) {
      setLoading(false);
      console.error('Error submitting weekly payroll:', error);
      enqueueSnackbar({
        variant: 'error',
        message: 'Failed to submit weekly payroll. Please try again later.',
      });
    }
  });

  return (
    <div style={ { marginLeft: '15px' } }>
      <FormProvider methods={ methods } onSubmit={ onSubmit }>
        <div
          style={ {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '16px',
          } }
        >
          <h2>WEEKLY PAYROLL / TIMESHEET</h2>
          <Button variant="contained" className="dark-button" onClick={ handleBack }>
            Back to List
          </Button>
        </div>
        <Box
          mt={ 2 }
          rowGap={ 2 }
          columnGap={ 2 }
          display="grid"
          gridTemplateColumns={ {
            xs: 'repeat(1, 1fr)',
            sm: 'repeat(3, 3fr)',
          } }
          sx={ { marginTop: '10px', padding: '20px' } }
        >
          <Controller
            name="week_starting_date"
            control={ control }
            render={ ({ field, fieldState: { error } }) => (
              <DatePicker
                label="Week Start Date"
                { ...field }
                inputFormat="yyyy-MM-dd"
                renderInput={ (params) => (
                  <TextField { ...params } fullWidth error={ !!error } helperText={ error?.message } />
                ) }
              />
            ) }
          />

          <RHFAutocomplete
            name="facility"
            label="Facility"
            options={ projectList }
            getOptionLabel={ (option) => option?.name || '' }
            isOptionEqualToValue={ (option, value) => option?.id === value?.id }
            renderOption={ (props, option) => (
              <li { ...props } key={ option.id }>
                { option.name }
              </li>
            ) }
            disabled 
            control={ control }
          />

          <RHFTextField name="scope_of_work" label="Scope of Work" />
          
          <ProjectManagerADD
            label="supervisor_id"
            name="supervisor_id"
            project_id={id}
            type='Supervisor'
            value={defaultValues?.supervisor_id} // Set default value from rowData
            onValueChange={(selectedUser) => setValue('supervisor_id', selectedUser?.id || '')}
          />
       

          <Controller
            name="week_ending_date"
            control={ control }
            render={ ({ field, fieldState: { error } }) => (
              <DatePicker
                label="Week End Date"
                { ...field }
                inputFormat="yyyy-MM-dd"
                //readOnly
                renderInput={ (params) => (
                  <TextField
                    { ...params }
                    fullWidth
                    error={ !!error }
                    helperText={ error?.message }
                  />
                ) }
              />
            ) }
          />

          <RHFTextField
            name="job_order_number"
            label="Job Order Number / Project Number"
            InputLabelProps={{ shrink: true }}
          />
        </Box>
        <Box
          sx={ {
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '16px',
            marginTop: '50px',
          } }
        >
          <Button
            sx={ { minWidth: 65, height: 35 } }
            className="dark-button"
            variant="contained"
            type="submit"
          >
            {rowData?.id ? "Update":  "Submit"}
          </Button>
          <Button
            sx={ { minWidth: 65, height: 35 } }
            className="dark-button"
            variant="contained"
            onClick={ () => reset(defaultValues) }
          >
            Cancel
          </Button>
        </Box>
      </FormProvider>

      <div style={ { marginTop: '40px' } }>
        <WeeklyPayrolltable data={ tableData } />

      </div>
    </div>
  );
};
export default WeeklyPayroll;